exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-cont-left[data-v-5bcc0cad]{\n\tmargin-top: 10px;\n}\n.page-cont-btm-right[data-v-5bcc0cad]{\n\tmargin-top: 10px;\n\tmargin-bottom: 20px;\n\tfloat: right;\n}\n\n\n", ""]);

// exports
